export const CACHE_SERVICE_DEFAULT_TIME_OF_LIFE = 30000;
